<div class="card">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="form" nzTheme="outline"></i> Payment Details
  </div>
  <div class="p-3">
    <form
      nz-form
      enctype="multipart/form-data"
      [formGroup]="paymentForm"
      (ngSubmit)="submitForm()"
    >
      <div class="form-row" style="margin-left: 12px">
        <div class="col-md-4">
          <nz-form-label style="margin-left: 15px" nzRequired
            >Amount Paid (in BDT)</nz-form-label
          >
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control
                [nzSpan]="null"
                nzHasFeedback
                [nzErrorTip]="amountErrorTpl"
              >
                <input
                  nz-input
                  formControlName="amount"
                  placeholder="Paid Amount"
                  type="number"
                  readonly
                />
                <ng-template #amountErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input amount!
                  </ng-container>
                  <ng-container *ngIf="control.hasError('min')">
                    Amount can not be negative!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <!-- Payment Date -->
        <div class="col-md-4">
          <nz-form-label nzRequired>Date of Payment</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback [nzErrorTip]="dateErrorTpl">
                <!-- <nz-date-picker nzFormat="yyyy-MM-dd" [nzDisabledDate]="disabledDate" id="paymentDate"
                  formControlName="paymentDate" placeholder="Payment Date" class="row">
                </nz-date-picker> -->
                <nz-date-picker
                  nzFormat="yyyy-MM-dd"
                  [nzDisabled]="true"
                  id="paymentDate"
                  formControlName="paymentDate"
                  placeholder="Payment Date"
                  class="row"
                >
                </nz-date-picker>
                <ng-template #dateErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input valid date!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <!-- Payment Date ends -->

        <div class="col-md-4">
          <nz-form-label nzRequired>Bank Name</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control nzHasFeedback [nzErrorTip]="banknameErrorTpl">
                <input
                  nz-input
                  formControlName="bankName"
                  placeholder="Bank Name"
                  readonly
                />
                <ng-template #banknameErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">
                    Please input bank name!
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="form-row" style="margin-left: 12px">
        <div class="col-md-4">
          <nz-form-label nzRequired>Upload Payment Slip</nz-form-label>
          <div class="col-md-12">
            <nz-form-item>
              <nz-form-control>
                <!-- <input [disabled]="onlinePayment" #myInput type="file" nz-input (change)="onSelectFile($event)"
                  accept="image/*,.pdf, .doc" nz-tooltip
                  nzTooltipTitle="Please upload pdf/ png/ jpg/ jpeg and 3mb size file"
                  nzTooltipPlacement="bottomLeft" /> -->
                <input
                  [disabled]="true"
                  #myInput
                  type="file"
                  nz-input
                  (change)="onSelectFile($event)"
                  accept="image/*,.pdf, .doc"
                  nz-tooltip
                  nzTooltipTitle="Please upload pdf/ png/ jpg/ jpeg and 3mb size file"
                  nzTooltipPlacement="bottomLeft"
                />
              </nz-form-control>
            </nz-form-item>
            <div></div>
          </div>
        </div>

        <div class="col-md-8" *ngIf="this.isPaymentExists">
          <div class="col-md-12 payment-message">
            <span *ngIf="onlinePayment"
              >* Online Paid Successfully. (Reference Number :
              {{ transactionNumber }} )
            </span>
            <span *ngIf="manualPayment">* Manually Paid Successfully. </span>
          </div>
        </div>
      </div>

      <div
        class="card shadow-lg border-0 rounded-3 overflow-hidden"
        *ngIf="
          (isPaymentInfoFound && !isPaymentCompleted) ||
          (isPaymentInfoFound && isPaymentCompleted && !isPaymentVerified)
        "
      >
        <!-- Header -->
        <div class="card-header bg-gradient bg-warning text-dark fw-bold fs-5">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          Caution: Payment Already Made?
        </div>

        <!-- Body -->
        <div class="card-body bg-light">
          <p class="fs-6 mb-4">
            If you have <strong>already made a payment</strong>, please follow
            these steps carefully to avoid duplicate payments:
          </p>

          <!-- Steps -->
          <div class="mb-4">
            <h6 class="fw-semibold text-primary mb-2">
              <i class="bi bi-list-check me-1"></i> Steps to Verify:
            </h6>
            <ol class="ps-3">
              <li class="mb-2">
                Do <span class="text-danger fw-bold">NOT</span> click the
                <em>“Pay Online”</em> button again.
              </li>
              <li class="mb-2">
                Click the <em>“Check &amp; Manage Payment”</em> button.
              </li>
              <li class="mb-2">
                Find your <strong>Application ID</strong> in the list
                (Application ID column).
              </li>
              <li class="mb-2">
                Check the <em>Payment Date</em>, <em>Amount</em>, and
                <em>Status</em>.
              </li>
            </ol>
          </div>

          <!-- Status Guide -->
          <h6 class="fw-semibold text-primary mb-3">
            <i class="bi bi-info-circle me-1"></i> How to Read Payment Status:
          </h6>
          <div class="row g-3">
            <!-- Case A -->
            <div class="col-md-6">
              <div
                class="p-3 rounded border border-success bg-white h-100 shadow-sm"
              >
                <div class="d-flex align-items-center mb-2">
                  <span class="fs-5 text-success me-2">✅</span>
                  <span class="fw-bold text-success">Case A</span>
                </div>
                <ul class="small mb-2">
                  <li>
                    Application Payment Status =
                    <span class="badge bg-danger text-white">Unpaid</span>
                  </li>
                  <li>
                    EkPay Status = <span class="badge bg-success text-white">Paid</span>
                  </li>
                </ul>
                <p class="small text-muted mb-0">
                  Your payment was successful, but it is not yet linked to your
                  application.
                </p>
              </div>
            </div>

            <!-- Case B -->
            <div class="col-md-6">
              <div
                class="p-3 rounded border border-danger bg-white h-100 shadow-sm"
              >
                <div class="d-flex align-items-center mb-2">
                  <span class="fs-5 text-danger me-2">❌</span>
                  <span class="fw-bold text-danger">Case B</span>
                </div>
                <ul class="small mb-2">
                  <li>
                    Application Payment Status =
                    <span class="badge bg-danger text-white">Unpaid</span>
                  </li>
                  <li>
                    EkPay Status = <span class="badge bg-danger text-white">Unpaid</span>
                  </li>
                </ul>
                <p class="small text-muted mb-0">
                  No successful payment is linked yet. Don’t worry—this may
                  happen due to network or server issues.
                </p>
              </div>
            </div>
          </div>

          <!-- Final Note -->
          <div class="alert alert-info mt-4 mb-0 border-0 shadow-sm rounded-2">
            <i class="bi bi-lightbulb-fill me-2"></i>
            For both <strong>Case A</strong> and <strong>Case B</strong>, click
            the <em>“Manage Payment”</em> button in the list. <br />
            Your payment will then be <strong>automatically linked</strong> to
            your application.
          </div>
        </div>
      </div>

      <div class="row justify-content-md-center">
        <div class="col-md-5" style="text-align: center">
          <button
            [disabled]="this.isPaymentExists"
            style="margin: 25px"
            nz-button
            nzShape="round"
            type="button"
            nzType="primary"
            (click)="onSubmitPaymentRequest()"
          >
            Pay Online
          </button>
        </div>
      </div>

      <div class="row justify-content-center media-button mt-4">
        <div
          class="col-xs-6 col-sm-3"
          *ngIf="
            (isPaymentInfoFound && !isPaymentCompleted) ||
            (isPaymentInfoFound && isPaymentCompleted && !isPaymentVerified)
          "
        >
          <button
            type="button"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            nz-tooltip
            [nzTooltipTitle]="
              isCheckAndManagePaymentBtnClick === false
                ? 'If your payment for this stp was successful but hasn’t been tagged yet, click this button to manage it.'
                : 'No need to manage? Press this button again.'
            "
            nzTooltipPlacement="bottomLeft"
            nz-popconfirm
            [nzPopconfirmTitle]="
              isCheckAndManagePaymentBtnClick === false
                ? 'Payment successful but not tagged yet? Manage now?'
                : 'No need to manage? Press this button again?'
            "
            nzPopconfirmPlacement="top"
            (nzOnConfirm)="checkAndManagePayment()"
          >
            <span nz-icon nzType="setting" nzTheme="outline"></span>
            Check & Manage Payment
          </button>
        </div>
        <div class="col-xs-6 col-sm-3">
          <button
            type="button"
            class="btn btn-info active btn-lg btn-block cari border-redius"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure?"
            (nzOnConfirm)="previousPage()"
            (nzOnCancel)="cancel()"
          >
            <i nz-icon nzType="backward" nzTheme="fill"></i> Previous
          </button>
        </div>

        <!-- <div class="col-xs-6 col-sm-2"> -->
        <!-- <button *ngIf="!isPaymentExists" type="submit"
            class="btn btn-success active btn-lg btn-block cari border-redius" [disabled]="!paymentForm.valid"
            (click)="submitFormAndApply()"><i nz-icon nzType="save" nzTheme="fill"></i>
            Save</button>

          <button *ngIf="isPaymentExists" type="submit"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            [disabled]="!paymentForm.valid && isPaymentExists" (click)="submitFormAndApply()"><i nz-icon nzType="save"
              nzTheme="fill"></i>
            {{manualPayment?'Update':'Save'}}</button> -->

        <!-- <button *ngIf="!this.isPaymentExists" type="submit"
            class="btn btn-success active btn-lg btn-block cari border-redius" [disabled]="true"
            (click)="submitFormAndApply()"><i nz-icon nzType="save" nzTheme="fill"></i>
            Save</button>

          <button *ngIf="this.isPaymentExists" type="submit"
            class="btn btn-success active btn-lg btn-block cari border-redius"
            [disabled]="true" (click)="submitFormAndApply()"><i nz-icon nzType="save"
              nzTheme="fill"></i>
            {{manualPayment?'Update':'Save'}}</button> -->
        <!-- </div> -->

        <!-- <div class="col-xs-6 col-sm-2">
          <button type="button" class="btn btn-danger active btn-lg btn-block cari border-redius"
            (click)="resetForm()"><i nz-icon nzType="redo" nzTheme="outline"></i> Reset</button>
        </div> -->
        <div *ngIf="this.isPaymentExists" class="col-xs-6 col-sm-3">
          <button
            type="button"
            class="btn btn-primary active btn-lg btn-block cari border-redius"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure to complete application?"
            nzPopconfirmPlacement="bottom"
            (nzOnConfirm)="onApplyApplication()"
          >
            <i nz-icon nzType="forward" nzTheme="fill"></i>Complete Application
          </button>
        </div>
      </div>
    </form>

    <div class="alert alert-warning mt-3" role="alert" *ngIf="notifyMsg">
      <b>*** Need to fill up:</b> {{ notifyMsg }} form.
    </div>
  </div>
</div>

<!-- new design -->
<div
  class="container-fluid"
  style="padding: 0"
  *ngIf="isCheckAndManagePaymentBtnClick"
>
  <!-- <div class="ng-Header col-xs-12">
    <i nz-icon nzType="search" nzTheme="outline"></i> Search
  </div>
  <form
    nz-form
    [formGroup]="searchForm"
    (ngSubmit)="submitSearchForm()"
    class="ant-advanced-search-form"
    style="
      padding: 24px;
      background: #fbfbfb;
      border: 1px solid #d9d9d9;
      border-radius: 6px;
    "
  >
    <div class="form-row" style="margin-left: 12px">
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>Transaction ID</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <input
                nz-input
                placeholder="Transaction ID"
                formControlName="transactionId"
                id="transactionId"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>Payment Date</nz-form-label>
          <nz-form-item>
            <nz-form-control
              nzHasFeedback
              nz-col
              nzErrorTip="Please insert valid Date"
            >
              <nz-date-picker
                formControlName="paymentDate"
                placeholder="Payment Date"
                style="width: 100%"
              >
              </nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div class="col-md-4">
        <div class="col-md-12">
          <nz-form-label>Payment Status</nz-form-label>
          <nz-form-item>
            <nz-form-control>
              <nz-select
                id="isSuccess"
                nzShowSearch
                nzAllowClear
                formControlName="isSuccess"
                nzPlaceHolder="Select one"
              >
                <nz-option
                  *ngFor="let status of paymentStatusList"
                  [nzValue]="status.value"
                  [nzLabel]="status.name"
                >
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </div>

    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area text-right">
        <button
          type="submit"
          class="ml-2 col-md-2 col-sm-12 mt-2"
          nz-button
          [nzType]="'primary'"
        >
          Search
        </button>
        <button
          class="btn-success ml-2 col-md-2 col-sm-12 mt-2"
          nz-button
          (click)="onRefresh()"
        >
          Refresh Data
        </button>
      </div>
    </div>
  </form> -->

  <div class="ng-Header col-xs-12 mt-4">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> STP Payment
    History
  </div>
  <div nz-col [nzSpan]="24">
    <nz-table
      #basicTable
      [nzData]="paymentHistoryResponse"
      nzTableLayout="fixed"
      nzShowSizeChanger
      nzBordered
      nzSize="middle"
      nzAlign="middle"
      [nzFrontPagination]="false"
      [nzTotal]="total"
      [(nzPageSize)]="size"
      [nzShowTotal]="totalRowRangeTemplate"
      [(nzPageIndex)]="page"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzPaginationPosition]="'both'"
      [nzScroll]="{ x: '1130px' }"
    >
      <ng-template
        #totalRowRangeTemplate
        let-range="range"
        let-total
        style="text-align: left"
      >
        <div style="text-align: left">
          Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
        </div>
      </ng-template>
      <thead>
        <tr style="overflow: auto">
          <th style="width: 100px; text-align: center" rowspan="1">Sl.</th>
          <th style="text-align: center" nzColumnKey="transaction_no">
            Transaction ID
          </th>
          <th style="text-align: center" nzColumnKey="b.batch_id">
            Application ID
          </th>
          <th style="text-align: center" nzColumnKey="pay_date">
            Payment Date
          </th>
          <th style="text-align: center" nzColumnKey="bank_name">
            Payment Gateway
          </th>
          <th style="text-align: center" nzColumnKey="amount">Amount</th>
          <th style="text-align: center" nzColumnKey="is_success">
            Application's Current Payment Status
          </th>
          <th style="text-align: center" nzColumnKey="is_success">
            Ekpay Status
          </th>
          <th style="text-align: center" nzRight>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index">
          <td style="text-align: center">{{ (page - 1) * size + 1 + i }}</td>

          <td style="text-align: center">
            {{ data.transactionId }}
          </td>
          <td style="text-align: center">
            {{ data.stpApplicationId }}
          </td>
          <td style="text-align: center">
            {{ data.paymentDate | date : "dd-MM-YYYY hh:mm:ss" }}
          </td>
          <td style="text-align: center">
            {{ data.bankName }}
          </td>
          <td style="text-align: center">
            {{ data.amount }}
          </td>
          <td style="text-align: center">
            <span
              [ngClass]="
                data.applicationCurrentPaymentStatus
                  ? 'badge bg-success text-white'
                  : 'badge bg-danger text-white'
              "
            >
              {{ data.applicationCurrentPaymentStatus ? "Paid" : "Unpaid" }}
            </span>
          </td>
          <td style="text-align: center">
            <span
              [ngClass]="
                data.isSuccess
                  ? 'badge bg-success text-white'
                  : 'badge bg-danger text-white'
              "
            >
              {{ data.isSuccess ? "Paid" : "Unpaid" }}
            </span>
          </td>
          <td style="text-align: center" nzRight>
            <button
              *ngIf="data.isSuccess == true"
              nz-button
              nzTheme="outline"
              nzType="primary"
              nz-tooltip
              nzTooltipTitle="Download"
              nzTooltipPlacement="bottomLeft"
              (click)="onDownloadJasperReport(data.ptId)"
              style="margin: 1%"
            >
              <i nz-icon nzType="download"></i>
            </button>
            <button
              type="button"
              aria-label="Manage Payment"
              [appRequiredPermission]="
                applicationPermissions.payment.paymentHistory
                  .regularAssessmentManagePaymentButtonPermission
              "
              nz-button
              nz-tooltip
              nzTooltipTitle="Manage Payment"
              nzTooltipPlacement="bottomLeft"
              nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to manage this payment?"
              (nzOnConfirm)="
                onValidatePayment(
                  data.id,
                  data.applicationId,
                  data.stpMainId,
                  data.transactionId,
                  data.paymentDate
                )
              "
              style="margin: 1%"
            >
              <i nz-icon nzType="dollar" nzTheme="outline"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
